/* eslint-disable */
/* tslint:disable */

/** getHublerSignedInformation
 * method: get
 * summary: Get a jwt containing the email, hubloId, and institutionIds of a hubler
 */

import type {
  GetHublerSignedInformationResponseDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/hubler/signed-information`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/hubler/signed-information`

export type GetHublerSignedInformationSuccess =
  GetHublerSignedInformationResponseDto
export type GetHublerSignedInformationError = ApiResponseDto
